<p-table [value]="groupedLotItems">
  <ng-template #header>
    <tr>
      <th>{{ 'Items_Inventory_Group_Item_Code' | translateWF: 'Item Code' }}</th>
      <th>{{ 'Items_Inventory_Group_Total_Quantity' | translateWF: 'Total Quantity (Lbs)' }}</th>
      <th>{{ 'Items_Inventory_Group_Lot_Items_Quantity' | translateWF: 'Lot Items Quantity' }}</th>
    </tr>
  </ng-template>
  <ng-template #body let-lot>
    <tr class="cursor-pointer">
      <td>{{ lot.itemCode }}</td>
      <td>{{ lot.totalNetQuantity | number: '1.2-2' }}</td>
      <td>{{ lot.lotItemsQuantity }}</td>
    </tr>
  </ng-template>
</p-table>
